const {
  PERMATE_CLICK_KEY,
  PERMATE_OFFER_KEY,
} = require('@src/constants/permate');
const { getCookie } = require('./cookie');

export const getClickIdFromCookie = () => {
  try {
    const pmClick = getCookie(PERMATE_CLICK_KEY);
    if (!pmClick) return null;
    const decodedPmClickValue = decodeURIComponent(pmClick);

    const jsonPmClickValue = JSON.parse(decodedPmClickValue);
    const clickUuid = jsonPmClickValue?.click;
    return clickUuid;
  } catch (error) {
    return null;
  }
};

export const getOfferIdFromCookie = () => {
  try {
    const pmOffer = getCookie(PERMATE_OFFER_KEY);
    if (!pmOffer) return null;

    const pmOfferDecoded = decodeURIComponent(pmOffer);
    const base64PmOfferDecoded = atob(pmOfferDecoded);
    const fixedPmOfferJson = base64PmOfferDecoded
      .replace(/'/g, '"')
      .replace(/(\w+):/g, '"$1":');
    const jsonPmOfferValue = JSON.parse(fixedPmOfferJson);

    const offerId = Number(jsonPmOfferValue?.pm_offer_id);
    return offerId;
  } catch (error) {
    return null;
  }
};
